module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "container options-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pull-right button-box"
  }, [_vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning margin-20 bold-600",
    class: {
      'disabled': _vm.isLoadPromo
    },
    on: {
      "click": function($event) {
        return _vm.choose(_vm.economicoManual)
      }
    }
  }, [_vm._v("\n            Econômico Manual\n            "), _c('i', {
    staticClass: "icon-circle-right align-icon-right"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning bold-600",
    class: {
      'disabled': _vm.isLoadPromo
    },
    on: {
      "click": function($event) {
        return _vm.choose(_vm.economicoAuto)
      }
    }
  }, [_vm._v("\n            Econômico Automático\n            "), _c('i', {
    staticClass: "icon-circle-right align-icon-right"
  })])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "messageDialog",
      "tabindex": "-1",
      "role": "dialog",
      "data-keyboard": "false",
      "data-backdrop": "static"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text-center pull-right"
  }, [_vm._m(7), _vm._v(" "), _c('h4', {
    staticClass: "margin-t10"
  }, [_vm._v("Veja nossos outros planos:")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning bold-600 margin-t10",
    attrs: {
      "href": "#/servicos-b2c"
    },
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("Ver outros planos")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row header-box"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('img', {
    staticClass: "logo-promo",
    attrs: {
      "src": require("../../../static/logo-promo-relampago.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('img', {
    staticClass: "logo-mm",
    attrs: {
      "src": require("../../../static/logo-movemais-promo-header.svg"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "container margin-t20 economic-plan"
  }, [_c('div', {
    staticClass: "pull-left plan-box"
  }, [_c('h1', {
    staticClass: "bold text-center margin-b20"
  }, [_vm._v("PLANO ECONÔMICO")]), _vm._v(" "), _c('span', {
    staticClass: "text-yellow bold-600"
  }, [_vm._v("Vantagens:")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    staticClass: "icon-bolt",
    attrs: {
      "src": require("../../../static/icon-bolt.svg"),
      "alt": ""
    }
  }), _vm._v("\n              Plano Pré-pago sem taxa de adesão\n            ")]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "icon-bolt",
    attrs: {
      "src": require("../../../static/icon-bolt.svg"),
      "alt": ""
    }
  }), _vm._v("\n              Receba sua(s) TAG(s) em casa, com frete grátis\n            ")]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "icon-bolt",
    attrs: {
      "src": require("../../../static/icon-bolt.svg"),
      "alt": ""
    }
  }), _vm._v("\n              R$ 25,00 ou mais para aderir\n            ")]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "icon-bolt",
    attrs: {
      "src": require("../../../static/icon-bolt.svg"),
      "alt": ""
    }
  }), _vm._v("\n              A primeira taxa de recarga é grátis\n            ")]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "icon-bolt",
    attrs: {
      "src": require("../../../static/icon-bolt.svg"),
      "alt": ""
    }
  }), _vm._v("\n              Receba seu dinheiro em crédito para utilização\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('img', {
    staticClass: "icon-bolt-money",
    attrs: {
      "src": require("../../../static/img-promo-bolt-saving-money2.svg"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left bolt-option-box"
  }, [_c('img', {
    staticClass: "icon-bolt-option",
    attrs: {
      "src": require("../../../static/img-promo-bolt-pre-pays-option.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Temos duas modalidades do plano,"), _c('br'), _vm._v(" selecione a melhor para você:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "container margin-b80 faq-box"
  }, [_c('h2', {
    staticClass: "text-yellow bold"
  }, [_vm._v("Dúvidas?")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("\n          Para tirar dúvidas ou saber mais informações sobre o plano, basta entrar em contato com a nossa Central de\n          Relacionamento nos telefones "), _c('b', [_vm._v("4000 2901")]), _vm._v(" (Capitais e regiões metropolitanas) ou "), _c('b', [_vm._v("0800 777 1022")]), _vm._v(" (demais localidades).\n        ")]), _vm._v(" "), _c('h4', [_vm._v("Você também pode tirar suas dúvidas no nosso FAQ:")]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-20"
  }, [_c('div', {
    staticClass: "accordion-click"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Quanto custa a adesão do Plano Econômico?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_vm._v("\n              A taxa de adesão e o envio da(s) TAG(s) são grátis neste plano, você só irá investir o valor da\n              primeira recarga (que é necessária no ato da adesão), porém a primeira recarga será sem nenhuma taxa,\n              ou seja, você irá utilizar o valor total nas passagens de pedágio. O valor mínimo de recarga para este\n              plano é R$ 25,00 reais, mas você é livre para fazer uma recarga de maior valor.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('div', {
    staticClass: "accordion-click"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Existe cobrança de mensalidade?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_vm._v("\n              Não, este plano não tem mensalidade.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('div', {
    staticClass: "accordion-click"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Pré-pago Manual ou Pré-pago Automático, qual escolho?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_vm._v("\n              Se você deseja ter controle total sobre os custos vá de Econômico Manual, se você não quer se preocupar\n              com recargas ou saldo insuficiente, vá de Econômico Automático.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('div', {
    staticClass: "accordion-click"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Tem limite de veículos?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_vm._v("\n              Não, você pode incluir quantos veículos quiser.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box"
  }, [_c('div', {
    staticClass: "accordion-click"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Pessoa Jurídica pode escolher esse plano?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_vm._v("\n              Não, este plano é destinado somente a pessoas físicas.\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h1', {
    staticClass: "modal-title bold text-center"
  }, [_vm._v("TEMPO ESGOTADO!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left bolt-option-box"
  }, [_c('img', {
    staticClass: "icon-bolt-option",
    attrs: {
      "src": require("../../../static/img-promo-bolt-chronometer.svg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "bold-600 margin-30"
  }, [_vm._v("Infelizmente essa promoção "), _c('br'), _vm._v(" não está mais disponível.")])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-2bdd7bbe!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/promo-bolt.vue
// module id = 2080
// module chunks = 1